'use client';
import React from 'react';
export var CheckboxGroupContext = /*#__PURE__*/React.createContext(void 0);